/* eslint-disable */
import React, { useState } from "react";
import {
  Card,
  Avatar,
  Text,
  ActionIcon,
  Box,
  createStyles,
  Stack,
  Loader,
  Center,
  Image,
  Group,
  Badge,
} from "@mantine/core";
import { IconEdit } from "@tabler/icons-react";
import { useGetUser } from "api/users/getUser";
import { useGetUserPrograms } from "api/program/getUserPrograms";
import UpdateUserProfileModal from "features/user-settings/components/updateuserProfile";
// import UpdateUserProfileModal from "./updateuserProfile";

const useStyles = createStyles((theme) => ({
  card: {
    borderRadius: 8,
    overflow: "hidden",
    border: `1px solid ${theme.colors.gray[2]}`,
    boxShadow: theme.shadows.xs,
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: 16,
    backgroundColor: theme.colors.dark[8],
    color: theme.white,
  },

  avatar: {
    border: `3px solid rgba(255,255,255,0.08)`,
  },

  nameBlock: {
    flex: 1,
    minWidth: 0,
  },

  name: {
    fontWeight: 700,
    fontSize: 16,
    lineHeight: 1,
  },

  subtitle: {
    display: "flex",
    gap: 8,
    alignItems: "center",
    color: theme.colors.gray[3],
    marginTop: 6,
    fontSize: 13,
  },

  editIcon: {
    backgroundColor: "rgba(255,255,255,0.06)",
    color: theme.white,
    borderRadius: 999,
  },

  body: {
    padding: 14,
    backgroundColor: theme.white,
  },

  label: {
    fontSize: 12,
    color: theme.colors.gray[5],
    marginBottom: 3,
  },

  value: {
    fontSize: 15,
    fontWeight: 600,
    color: theme.colors.dark[6],
    marginBottom: 4,
    wordBreak: "break-word",
  },
}));

export default function ProfileCard() {
  const { classes } = useStyles();
  const { data: userData, isLoading } = useGetUser();
  const { data: programsData, isLoading: programsLoading } = useGetUserPrograms(userData?._id ?? null);
  
  const [opened, setOpened] = useState(false);
  if (isLoading) {
    return (
      <Center style={{ height: 160 }}>
        <Loader />
      </Center>
    );
  }

  if (!userData) {
    return (
      <Card className={classes.card} radius="md">
        <Box className={classes.body}>
          <Text color="red">User not found.</Text>
        </Box>
      </Card>
    );
  }

  const fullName = `${userData.firstName ?? ""} ${
    userData.lastName ?? ""
  }`.trim();
  const initials =
    fullName
      .split(" ")
      .filter(Boolean)
      .map((n) => n[0])
      .slice(0, 2)
      .join("") || "?";

  const phone = userData.personalInfo?.phoneNumber ?? "—";
  const email = userData.email ?? "—";
  const role = userData.role ?? "—";

  const resolveDepartment = () => {
    const org: any = userData.org;
    const dept = userData.department ?? org?.department ?? null;

    if (!dept) {
      return { name: org?.name ?? "—", logo: null };
    }

    if (typeof dept === "object" && dept?.name) {
      return { name: String(dept.name), logo: dept?.logo || null };
    }

    return { name: String(dept), logo: null };
  };

  const address = userData.personalInfo?.address ?? "—";
  const departmentData = resolveDepartment();
  const department = departmentData.name;
  const departmentLogo = departmentData.logo;
  return (
    <Card className={classes.card} radius="md">
      <Box className={classes.header}>
        <Avatar
          className={classes.avatar}
          radius="xl"
          size={56}
          src={(userData as any).avatar || undefined}
        >
          {initials}
        </Avatar>

        <div className={classes.nameBlock}>
          <Text className={classes.name}>{fullName || "No name"}</Text>

          <div className={classes.subtitle}>
            <Text style={{ fontWeight: 600, fontSize: 13 }}>{role}</Text>
          </div>
        </div>

        <ActionIcon
          size={36}
          className={classes.editIcon}
          aria-label="Edit"
          onClick={() => {
            setOpened(true);
          }}
        >
          <IconEdit size={16} />
        </ActionIcon>
      </Box>

      <Box className={classes.body}>
        <Stack spacing={10}>
          <div>
            <Text className={classes.label}>Phone Number</Text>
            <Text className={classes.value}>{phone}</Text>
          </div>

          <div>
            <Text className={classes.label}>Email Address</Text>
            <Text className={classes.value}>{email}</Text>
          </div>

          <div>
            <Text className={classes.label}>Department</Text>
            {departmentLogo ? (
              <Group spacing={8} align="center">
                <Image
                  src={departmentLogo}
                  alt={`${department} logo`}
                  width={80}
                  height={80}
                  fit="contain"
                  styles={{
                    root: { maxWidth: 80 },
                    image: { objectFit: 'contain' }
                  }}
                />
                <Text className={classes.value}>{department}</Text>
              </Group>
            ) : (
              <Text className={classes.value}>{department}</Text>
            )}
          </div>

          <div>
            <Text className={classes.label}>Address</Text>
            <Text className={classes.value}>{address}</Text>
          </div>

          <div>
            <Text className={classes.label}>Programs</Text>
            {programsLoading ? (
              <Loader size="xs" />
            ) : programsData?.data && programsData.data.length > 0 ? (
              <Group spacing={6} style={{ marginTop: 6 }}>
                {programsData.data.map((program) => (
                  <Badge key={program._id} size="md" variant="light">
                    {program.name}
                  </Badge>
                ))}
              </Group>
            ) : (
              <Text className={classes.value}>No programs assigned</Text>
            )}
          </div>
        </Stack>
      </Box>
      <UpdateUserProfileModal
        // user={user ?? undefined}
        userId={userData?._id ?? ''}
        opened={opened}
        onClose={() => setOpened(false)}
      />
    </Card>
  );
}
